import { gql } from '@apollo/client';

// Operation names `StudentDiplomas` / `StudentDiplomaDownloadUrl` are deliberately
// distinct from the backend fields `myDiplomas` / `myDiplomaDownloadUrl` — equal
// operation/field names make codegen collapse the generated result type into the
// schema payload type (see the graphql-codegen skill, and queries/invoices.ts).
//
// NB: "diploma" here is the diploma CERTIFICATE (the PDF issued at graduation),
// not the `graduationProject` / дипломный проект that lives on the lesson tabs.
export const StudentDiplomasQuery = gql`
  query StudentDiplomas {
    myDiplomas {
      id
      language
      groupName
      courseName
      originalName
      sizeBytes
      issuedAt
    }
  }
`;

/**
 * Short-TTL presigned GET link for one diploma — minted per click and always
 * fetched over the network, never served from the cache (a cached link is
 * expired by definition). Never prefetch these into the list: the URL is a
 * bearer token for a personal legal document.
 */
export const StudentDiplomaDownloadUrlQuery = gql`
  query StudentDiplomaDownloadUrl($diplomaId: ID!) {
    myDiplomaDownloadUrl(diplomaId: $diplomaId) {
      url
      expiresAt
    }
  }
`;
